<div class="file-drop-area">
  <button mat-raised-button color="primary">Choose file</button>
  <span>{{file ? file.name : ' or drag and drop file here' }}</span>
  <input class="file-input" type="file">
</div>
